__turbopack_context__.v({
  "caret": "checkbox_dropdown-module-scss-module__Me-B1a__caret",
  "dropdown": "checkbox_dropdown-module-scss-module__Me-B1a__dropdown",
  "dropdownButton": "checkbox_dropdown-module-scss-module__Me-B1a__dropdownButton",
  "fullWidth": "checkbox_dropdown-module-scss-module__Me-B1a__fullWidth",
  "menu": "checkbox_dropdown-module-scss-module__Me-B1a__menu",
  "menuItem": "checkbox_dropdown-module-scss-module__Me-B1a__menuItem",
  "menuLabel": "checkbox_dropdown-module-scss-module__Me-B1a__menuLabel",
  "open": "checkbox_dropdown-module-scss-module__Me-B1a__open",
  "slider": "checkbox_dropdown-module-scss-module__Me-B1a__slider",
  "switch": "checkbox_dropdown-module-scss-module__Me-B1a__switch",
});
